import Vue from 'vue'
import Store from '../core'
import { version } from 'vuex/package.json'

Vue.$app = Vue.$app || {}

Vue.$app.store = Store
Vue.$app.store.version = version
